import { useEffect, useMemo, useState } from "react"

export const useEmployeeFinanaceDetails = () => {

    const [rowData, setRowData] = useState([]);
    const [showPopUp, setShowPopUp] = useState(false)

    const columnDefs = [
        {
            headerName: "Employee Id",
            field: "employee_id",
            cellStyle: { textAlign: "center" },
            width: 100,
        },
        {
            headerName: "Name",
            field: "user_display_name",
            cellStyle: { textAlign: "center" },
            width: 150,
        },
        {
            headerName: "Gender",
            field: "gender",
            cellStyle: { textAlign: "center" },
            width: 80,
        },
        {
            headerName: "Email",
            field: "email_id",
            cellStyle: { textAlign: "center" },
            width: 150,
        },
        {
            headerName: "Mobile Number",
            field: "mobile_number",
            cellStyle: { textAlign: "center" },
            width: 100,
        },
        {
            headerName: "Designation",
            field: "designation",
            cellStyle: { textAlign: "center" },
            width: 100,
        },
        {
            headerName: "Experiance in Year",
            field: "experiance",
            cellStyle: { textAlign: "center" },
            width: 80,
        },
        {
            headerName: "Business unit",
            field: "business_unit",
            cellStyle: { textAlign: "center" },
            width: 120,
        },
        {
            headerName: "Sub Business Unit",
            field: "sub_business_unit",
            cellStyle: { textAlign: "center" },
            width: 120,
        },
        {
            headerName: "Primary Project",
            field: "primary_project",
            cellStyle: { textAlign: "center" },
            width: 120,
        },
        {
            headerName: "Primary Technology",
            field: "primary_technology",
            cellStyle: { textAlign: "center" },
            width: 120,
        },
    ]

    return useMemo(() => ({
        columnDefs, rowData, showPopUp, setShowPopUp
    }), [columnDefs, rowData, showPopUp, setShowPopUp])
}

